// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/client/auth/auth.proto" (package "mlmbox.client.auth", syntax proto3)
// tslint:disable
import { Account_Id } from "../../types/account.ts";
import { Empty } from "../../../google/protobuf/empty.ts";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Account_Info } from "../../types/account.ts";
import { Status_TokenValidate } from "../../types/status.ts";
import { Status_Referral } from "../../types/status.ts";
import { Status_Auth } from "../../types/status.ts";
/**
 * @generated from protobuf message mlmbox.client.auth.TelegramBotSignRequest
 */
export interface TelegramBotSignRequest {
    /**
     * @generated from protobuf field: uint32 channel_id = 1;
     */
    channelId: number;
    /**
     * @generated from protobuf field: string init_data = 2;
     */
    initData: string;
}
/**
 * @generated from protobuf message mlmbox.client.auth.AuthSignResponse
 */
export interface AuthSignResponse {
    /**
     * @generated from protobuf field: mlmbox.types.Status.Auth auth_status = 1;
     */
    authStatus: Status_Auth; // Authentication status
    /**
     * @generated from protobuf field: mlmbox.types.Status.Referral referral_status = 2;
     */
    referralStatus: Status_Referral; // Referral status
    /**
     * @generated from protobuf field: string access_token = 3;
     */
    accessToken: string; // The token is used in the "authorization: X.Y.Z" header to make authorized API requests
}
/**
 * @generated from protobuf message mlmbox.client.auth.TokenValidateResponse
 */
export interface TokenValidateResponse {
    /**
     * @generated from protobuf field: mlmbox.types.Status.TokenValidate status = 1;
     */
    status: Status_TokenValidate;
}
/**
 * @generated from protobuf message mlmbox.client.auth.TokenGenerateResponse
 */
export interface TokenGenerateResponse {
    /**
     * @generated from protobuf field: string access_token = 1;
     */
    accessToken: string;
}
/**
 * @generated from protobuf message mlmbox.client.auth.RemoteSignInEvent
 */
export interface RemoteSignInEvent {
    /**
     * @generated from protobuf oneof: event
     */
    event: {
        oneofKind: "guestAccessToken";
        /**
         * @generated from protobuf field: string guest_access_token = 1;
         */
        guestAccessToken: string;
    } | {
        oneofKind: "secretCode";
        /**
         * @generated from protobuf field: mlmbox.client.auth.RemoteSignInEvent.SecretCode secret_code = 2;
         */
        secretCode: RemoteSignInEvent_SecretCode;
    } | {
        oneofKind: "waiting";
        /**
         * @generated from protobuf field: mlmbox.client.auth.RemoteSignInEvent.Waiting waiting = 3;
         */
        waiting: RemoteSignInEvent_Waiting;
    } | {
        oneofKind: "accountAccessToken";
        /**
         * @generated from protobuf field: string account_access_token = 4;
         */
        accountAccessToken: string;
    } | {
        oneofKind: "canceled";
        /**
         * @generated from protobuf field: mlmbox.types.Account.Info canceled = 5;
         */
        canceled: Account_Info;
    } | {
        oneofKind: "waitingExpired";
        /**
         * @generated from protobuf field: mlmbox.types.Account.Info waiting_expired = 6;
         */
        waitingExpired: Account_Info;
    } | {
        oneofKind: "expiredAt";
        /**
         * @generated from protobuf field: uint32 expired_at = 7;
         */
        expiredAt: number;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message mlmbox.client.auth.RemoteSignInEvent.SecretCode
 */
export interface RemoteSignInEvent_SecretCode {
    /**
     * @generated from protobuf field: string value = 1;
     */
    value: string;
    /**
     * @generated from protobuf field: uint32 expired_at = 2;
     */
    expiredAt: number;
}
/**
 * @generated from protobuf message mlmbox.client.auth.RemoteSignInEvent.Waiting
 */
export interface RemoteSignInEvent_Waiting {
    /**
     * @generated from protobuf field: mlmbox.types.Account.Info account = 1;
     */
    account?: Account_Info;
    /**
     * @generated from protobuf field: uint32 expired_at = 2;
     */
    expiredAt: number;
}
// @generated message type with reflection information, may provide speed optimized methods
class TelegramBotSignRequest$Type extends MessageType<TelegramBotSignRequest> {
    constructor() {
        super("mlmbox.client.auth.TelegramBotSignRequest", [
            { no: 1, name: "channel_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "init_data", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TelegramBotSignRequest>): TelegramBotSignRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.channelId = 0;
        message.initData = "";
        if (value !== undefined)
            reflectionMergePartial<TelegramBotSignRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TelegramBotSignRequest): TelegramBotSignRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 channel_id */ 1:
                    message.channelId = reader.uint32();
                    break;
                case /* string init_data */ 2:
                    message.initData = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TelegramBotSignRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 channel_id = 1; */
        if (message.channelId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.channelId);
        /* string init_data = 2; */
        if (message.initData !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.initData);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.client.auth.TelegramBotSignRequest
 */
export const TelegramBotSignRequest = new TelegramBotSignRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuthSignResponse$Type extends MessageType<AuthSignResponse> {
    constructor() {
        super("mlmbox.client.auth.AuthSignResponse", [
            { no: 1, name: "auth_status", kind: "enum", T: () => ["mlmbox.types.Status.Auth", Status_Auth, "AUTH_"] },
            { no: 2, name: "referral_status", kind: "enum", T: () => ["mlmbox.types.Status.Referral", Status_Referral, "REFERRAL_"] },
            { no: 3, name: "access_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AuthSignResponse>): AuthSignResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.authStatus = 0;
        message.referralStatus = 0;
        message.accessToken = "";
        if (value !== undefined)
            reflectionMergePartial<AuthSignResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AuthSignResponse): AuthSignResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* mlmbox.types.Status.Auth auth_status */ 1:
                    message.authStatus = reader.int32();
                    break;
                case /* mlmbox.types.Status.Referral referral_status */ 2:
                    message.referralStatus = reader.int32();
                    break;
                case /* string access_token */ 3:
                    message.accessToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AuthSignResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* mlmbox.types.Status.Auth auth_status = 1; */
        if (message.authStatus !== 0)
            writer.tag(1, WireType.Varint).int32(message.authStatus);
        /* mlmbox.types.Status.Referral referral_status = 2; */
        if (message.referralStatus !== 0)
            writer.tag(2, WireType.Varint).int32(message.referralStatus);
        /* string access_token = 3; */
        if (message.accessToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.accessToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.client.auth.AuthSignResponse
 */
export const AuthSignResponse = new AuthSignResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TokenValidateResponse$Type extends MessageType<TokenValidateResponse> {
    constructor() {
        super("mlmbox.client.auth.TokenValidateResponse", [
            { no: 1, name: "status", kind: "enum", T: () => ["mlmbox.types.Status.TokenValidate", Status_TokenValidate, "TOKEN_VALIDATE_"] }
        ]);
    }
    create(value?: PartialMessage<TokenValidateResponse>): TokenValidateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.status = 0;
        if (value !== undefined)
            reflectionMergePartial<TokenValidateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TokenValidateResponse): TokenValidateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* mlmbox.types.Status.TokenValidate status */ 1:
                    message.status = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TokenValidateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* mlmbox.types.Status.TokenValidate status = 1; */
        if (message.status !== 0)
            writer.tag(1, WireType.Varint).int32(message.status);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.client.auth.TokenValidateResponse
 */
export const TokenValidateResponse = new TokenValidateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TokenGenerateResponse$Type extends MessageType<TokenGenerateResponse> {
    constructor() {
        super("mlmbox.client.auth.TokenGenerateResponse", [
            { no: 1, name: "access_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TokenGenerateResponse>): TokenGenerateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessToken = "";
        if (value !== undefined)
            reflectionMergePartial<TokenGenerateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TokenGenerateResponse): TokenGenerateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_token */ 1:
                    message.accessToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TokenGenerateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_token = 1; */
        if (message.accessToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.client.auth.TokenGenerateResponse
 */
export const TokenGenerateResponse = new TokenGenerateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoteSignInEvent$Type extends MessageType<RemoteSignInEvent> {
    constructor() {
        super("mlmbox.client.auth.RemoteSignInEvent", [
            { no: 1, name: "guest_access_token", kind: "scalar", oneof: "event", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "secret_code", kind: "message", oneof: "event", T: () => RemoteSignInEvent_SecretCode },
            { no: 3, name: "waiting", kind: "message", oneof: "event", T: () => RemoteSignInEvent_Waiting },
            { no: 4, name: "account_access_token", kind: "scalar", oneof: "event", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "canceled", kind: "message", oneof: "event", T: () => Account_Info },
            { no: 6, name: "waiting_expired", kind: "message", oneof: "event", T: () => Account_Info },
            { no: 7, name: "expired_at", kind: "scalar", oneof: "event", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<RemoteSignInEvent>): RemoteSignInEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.event = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<RemoteSignInEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RemoteSignInEvent): RemoteSignInEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string guest_access_token */ 1:
                    message.event = {
                        oneofKind: "guestAccessToken",
                        guestAccessToken: reader.string()
                    };
                    break;
                case /* mlmbox.client.auth.RemoteSignInEvent.SecretCode secret_code */ 2:
                    message.event = {
                        oneofKind: "secretCode",
                        secretCode: RemoteSignInEvent_SecretCode.internalBinaryRead(reader, reader.uint32(), options, (message.event as any).secretCode)
                    };
                    break;
                case /* mlmbox.client.auth.RemoteSignInEvent.Waiting waiting */ 3:
                    message.event = {
                        oneofKind: "waiting",
                        waiting: RemoteSignInEvent_Waiting.internalBinaryRead(reader, reader.uint32(), options, (message.event as any).waiting)
                    };
                    break;
                case /* string account_access_token */ 4:
                    message.event = {
                        oneofKind: "accountAccessToken",
                        accountAccessToken: reader.string()
                    };
                    break;
                case /* mlmbox.types.Account.Info canceled */ 5:
                    message.event = {
                        oneofKind: "canceled",
                        canceled: Account_Info.internalBinaryRead(reader, reader.uint32(), options, (message.event as any).canceled)
                    };
                    break;
                case /* mlmbox.types.Account.Info waiting_expired */ 6:
                    message.event = {
                        oneofKind: "waitingExpired",
                        waitingExpired: Account_Info.internalBinaryRead(reader, reader.uint32(), options, (message.event as any).waitingExpired)
                    };
                    break;
                case /* uint32 expired_at */ 7:
                    message.event = {
                        oneofKind: "expiredAt",
                        expiredAt: reader.uint32()
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RemoteSignInEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string guest_access_token = 1; */
        if (message.event.oneofKind === "guestAccessToken")
            writer.tag(1, WireType.LengthDelimited).string(message.event.guestAccessToken);
        /* mlmbox.client.auth.RemoteSignInEvent.SecretCode secret_code = 2; */
        if (message.event.oneofKind === "secretCode")
            RemoteSignInEvent_SecretCode.internalBinaryWrite(message.event.secretCode, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* mlmbox.client.auth.RemoteSignInEvent.Waiting waiting = 3; */
        if (message.event.oneofKind === "waiting")
            RemoteSignInEvent_Waiting.internalBinaryWrite(message.event.waiting, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string account_access_token = 4; */
        if (message.event.oneofKind === "accountAccessToken")
            writer.tag(4, WireType.LengthDelimited).string(message.event.accountAccessToken);
        /* mlmbox.types.Account.Info canceled = 5; */
        if (message.event.oneofKind === "canceled")
            Account_Info.internalBinaryWrite(message.event.canceled, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* mlmbox.types.Account.Info waiting_expired = 6; */
        if (message.event.oneofKind === "waitingExpired")
            Account_Info.internalBinaryWrite(message.event.waitingExpired, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* uint32 expired_at = 7; */
        if (message.event.oneofKind === "expiredAt")
            writer.tag(7, WireType.Varint).uint32(message.event.expiredAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.client.auth.RemoteSignInEvent
 */
export const RemoteSignInEvent = new RemoteSignInEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoteSignInEvent_SecretCode$Type extends MessageType<RemoteSignInEvent_SecretCode> {
    constructor() {
        super("mlmbox.client.auth.RemoteSignInEvent.SecretCode", [
            { no: 1, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "expired_at", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<RemoteSignInEvent_SecretCode>): RemoteSignInEvent_SecretCode {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.value = "";
        message.expiredAt = 0;
        if (value !== undefined)
            reflectionMergePartial<RemoteSignInEvent_SecretCode>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RemoteSignInEvent_SecretCode): RemoteSignInEvent_SecretCode {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string value */ 1:
                    message.value = reader.string();
                    break;
                case /* uint32 expired_at */ 2:
                    message.expiredAt = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RemoteSignInEvent_SecretCode, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string value = 1; */
        if (message.value !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.value);
        /* uint32 expired_at = 2; */
        if (message.expiredAt !== 0)
            writer.tag(2, WireType.Varint).uint32(message.expiredAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.client.auth.RemoteSignInEvent.SecretCode
 */
export const RemoteSignInEvent_SecretCode = new RemoteSignInEvent_SecretCode$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoteSignInEvent_Waiting$Type extends MessageType<RemoteSignInEvent_Waiting> {
    constructor() {
        super("mlmbox.client.auth.RemoteSignInEvent.Waiting", [
            { no: 1, name: "account", kind: "message", T: () => Account_Info },
            { no: 2, name: "expired_at", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<RemoteSignInEvent_Waiting>): RemoteSignInEvent_Waiting {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expiredAt = 0;
        if (value !== undefined)
            reflectionMergePartial<RemoteSignInEvent_Waiting>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RemoteSignInEvent_Waiting): RemoteSignInEvent_Waiting {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* mlmbox.types.Account.Info account */ 1:
                    message.account = Account_Info.internalBinaryRead(reader, reader.uint32(), options, message.account);
                    break;
                case /* uint32 expired_at */ 2:
                    message.expiredAt = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RemoteSignInEvent_Waiting, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* mlmbox.types.Account.Info account = 1; */
        if (message.account)
            Account_Info.internalBinaryWrite(message.account, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* uint32 expired_at = 2; */
        if (message.expiredAt !== 0)
            writer.tag(2, WireType.Varint).uint32(message.expiredAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.client.auth.RemoteSignInEvent.Waiting
 */
export const RemoteSignInEvent_Waiting = new RemoteSignInEvent_Waiting$Type();
/**
 * @generated ServiceType for protobuf service mlmbox.client.auth.Auth
 */
export const Auth = new ServiceType("mlmbox.client.auth.Auth", [
    { name: "TelegramBotSign", options: {}, I: TelegramBotSignRequest, O: AuthSignResponse },
    { name: "TokenValidate", options: {}, I: Empty, O: TokenValidateResponse },
    { name: "TokenGenerate", options: {}, I: Account_Id, O: TokenGenerateResponse },
    { name: "RemoteSignIn", serverStreaming: true, options: {}, I: Empty, O: RemoteSignInEvent }
]);
